import type { IconData } from '@stacksjs/iconify-core'

export const cherries: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"3\"><path stroke-linejoin=\"bevel\" d=\"M13 5c4.023 2.479 8.209 3.538 12.597 3.905C29.602 9.24 35.202 8.74 39 6.583\"/><path stroke-linejoin=\"round\" d=\"M3 34a9 9 0 1 0 18 0a9 9 0 1 0-18 0\"/><path stroke-linejoin=\"round\" d=\"M27 9c-8.177 3.013-12.995 8.476-14 16M27 9c.577 3.75 1.657 8.219 4.761 11.746\"/><path stroke-linejoin=\"round\" d=\"M45 29a9 9 0 1 1-18 0a9 9 0 0 1 18 0\"/><path stroke-linejoin=\"round\" d=\"M40 29a4 4 0 0 0-4-4m-20 9a4 4 0 0 0-4-4\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default cherries
